import { cn } from '@/shared/lib/cn';

type RadioDotProps = { isChecked: boolean; className?: string };

export function RadioDot({ isChecked, className }: RadioDotProps) {
  return (
    <span
      data-slot="radio-dot"
      aria-hidden="true"
      className={cn(
        'inline-flex size-5 shrink-0 items-center justify-center rounded-full border-2',
        isChecked ? 'border-accent-mark' : 'border-muted',
        className,
      )}
    >
      {isChecked ? <span className="size-2.5 rounded-full bg-accent-mark" /> : null}
    </span>
  );
}
